import { ContainerPriceDict } from "./container-price-dict.type";
import { ContainerName } from "./container-name.type.const";
import { ContainerPrice } from "./container-price.model";
import { ContainerPriceDictMapper } from "./container-price-dict.mapper";
import { containerNames } from "./container.const";

export class ContainerPrices {
  private containerPriceDict = <ContainerPriceDict>{};

  constructor(data: ContainerPrices | ContainerPrice[]) {
    this.setContainerPriceDict(data);
  }

  public getPrices(): ContainerPriceDict {
    return this.containerPriceDict;
  }

  public setPrices(param: ContainerPriceDict) {
    this.containerPriceDict = param;
  }

  public getPrice(param: ContainerName): number {
    return this.getPrices()[param] ? this.getPrices()[param].getValue() : null;
  }

  public setPrice(param: ContainerName, val: number) {
    try {
      this.getPrices()[param] = new ContainerPrice(param, val);
    } catch (e) {
      console.error(`can't set ${param} container with ${val} (${e})`);
    }
  }

  public getContainerPriceNames(): ContainerName[] {
    return <ContainerName[]>Object.keys(this.containerPriceDict);
  }

  public getRequestParams() {
    return ContainerPriceDictMapper.toArray(this.containerPriceDict);
  }

  public setAllPrices(param: number): void {
    containerNames.forEach((containerName) => {
      this.setPrice(containerName, param);
    });
  }

  public areAllPricesEqual(param: number) {
    return this.getRequestParams().every(
      (containerPrice) => containerPrice.getValue() === param,
    );
  }

  public hasAllPrices(equipment: string[] = []) {
    return equipment
      .map((containerName) =>
        this.containerPriceDict[containerName]
          ? this.containerPriceDict[containerName]
          : null,
      )
      .every((val) => val !== null);
  }

  public hasAtLeastOnePrice(equipment: string[] = []) {
    return equipment
      .map((containerName) =>
        this.containerPriceDict[containerName]
          ? this.containerPriceDict[containerName]
          : null,
      )
      .some((val) => val.value !== null);
  }

  private setContainerPriceDict(data: ContainerPrices | ContainerPrice[]) {
    if (data instanceof ContainerPrices) {
      this.containerPriceDict = { ...data.getPrices() };
    }

    if (Array.isArray(data)) {
      this.containerPriceDict = ContainerPriceDictMapper.toDict(data);
    }
  }
}
